export default __webpack_public_path__ + "static/media/bin.e6fdb169.svg";